import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert,
  AlertTitle
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const FormSubmissionSuccess: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 4, my: 4, textAlign: 'center' }}>
        <CheckCircleIcon 
          sx={{ 
            fontSize: 80, 
            color: '#4caf50',
            mb: 2
          }} 
        />
        
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Thank You For Your Submission
        </Typography>

        <Typography variant="h6" sx={{ mb: 3, color: 'text.secondary' }}>
          Your application has been safely recorded
        </Typography>

        <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
          <AlertTitle>What happens next?</AlertTitle>
          <Typography variant="body2" paragraph>
            A confirmation email has been sent to your email address with details of your submission.
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>Don't see the email?</strong> Please check your spam or junk folder. 
            If you still can't find it, the confirmation may take a few minutes to arrive.
          </Typography>
          <Typography variant="body2">
            Rest assured, your application has been successfully submitted regardless of email delivery.
          </Typography>
        </Alert>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          {slug && (
            <Button
              variant="contained"
              onClick={() => navigate(`/guidelines/strand/${slug}`)}
              sx={{ 
                bgcolor: '#3A9188',
                '&:hover': { bgcolor: '#2D7A72' }
              }}
            >
              Review Guidelines
            </Button>
          )}
          
          <Button
            variant="outlined"
            onClick={() => navigate('/publicstrands')}
          >
            View Other Opportunities
          </Button>
        </Box>

        <Typography 
          variant="body2" 
          sx={{ 
            mt: 4, 
            color: 'text.secondary',
            fontStyle: 'italic'
          }}
        >
          If you have any questions, please contact us at admin[at]improvisedmusic[dot]ie
        </Typography>
      </Paper>
    </Container>
  );
};

export default FormSubmissionSuccess;